import React, { Component } from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import styles from './MinMaxPrices.scss';
import clearNumber from '../../helpers/clearNumber';
import beautifyNumber from '../../helpers/beautifyNumber';

const INPUT_TIME_OUT = 2000;

export default class MinMaxPrices extends Component {
  constructor(props) {
    super(props);
    this.state = {
      minPrice: props.minPrice.value,
      maxPrice: props.maxPrice.value,
      tOut: {
        minPrice: null,
        maxPrice: null
      }
    };
  }

  componentWillReceiveProps(nextProps) {
    const { minPrice: { value: minPrice }, maxPrice: { value: maxPrice } } = nextProps;
    this.setState({ minPrice, maxPrice });
  }

  onBlur = (field) => {
    if (this.state.tOut[field]) {
      clearTimeout(this.state.tOut[field]);
    }

    let value = this.state[field];

    if (field === 'maxPrice') {
      const minPrice = +clearNumber(this.props.minPrice.value);
      const maxPrice = +clearNumber(this.state.maxPrice);

      if (minPrice > maxPrice) {
        value = '';
      }
    }

    this.props[field].onChange(value);

    this.setState({
      tOut: {
        ...this.state.tOut,
        [field]: null
      }
    });
  };

  setTout = (value, field) => {
    if (clearNumber(value).length > 8) {
      return true;
    }

    if (this.state.tOut[field]) {
      clearTimeout(this.state.tOut[field]);
    }

    const tOut = setTimeout(() => this.onBlur(field), INPUT_TIME_OUT);

    if (field === 'minPrice' && !this.checkMinPrice(value)) {
      return clearTimeout(tOut);
    }

    const newValue = this.props.isMobile
      ? clearNumber(value)
      : beautifyNumber(clearNumber(value));

    return this.setState({
      [field]: newValue,
      tOut: {
        ...this.state.tOut,
        [field]: tOut
      }
    });
  };

  checkMinPrice = (value) => {
    const maxPrice = this.state.maxPrice && +clearNumber(this.state.maxPrice);

    if (!maxPrice) {
      return true;
    }

    const minPrice = +clearNumber(value);

    return minPrice <= maxPrice;
  };

  render() {
    const { translate, className, additionalClassName } = this.props;
    const dash = this.props.separator || ((this.props.inFilters) ? <span>-</span> : null);

    return (
      <div
        className={cx(
          styles.minMaxComponent,
          className,
          {
            [styles.inFilters]: this.props.inFilters,
            [styles[className]]: className
          },
          additionalClassName
        )}
      >
        <div className={styles.control}>
          <input
            name="min-price-select"
            type="text"
            placeholder={this.props.minPlaceholder || `${translate('min_price')}`}
            value={this.state.minPrice || ''}
            onChange={evt => this.setTout(evt.target.value, 'minPrice')}
            onBlur={() => this.onBlur('minPrice')}
          />
        </div>
        {dash}
        <div className={styles.control}>
          <input
            name="max-price-select"
            type="text"
            placeholder={this.props.maxPlaceholder || `${translate('max_price')}`}
            value={this.state.maxPrice || ''}
            onChange={evt => this.setTout(evt.target.value, 'maxPrice')}
            onBlur={() => this.onBlur('maxPrice')}
          />
        </div>
      </div>
    );
  }
}

MinMaxPrices.propTypes = {
  minPrice: PropTypes.object,
  maxPrice: PropTypes.object,
  translate: PropTypes.func,
  className: PropTypes.string,
  additionalClassName: PropTypes.string,
  inFilters: PropTypes.bool, // TODO: Move it to the parent container
  isMobile: PropTypes.bool,
  separator: PropTypes.string,
  minPlaceholder: PropTypes.string,
  maxPlaceholder: PropTypes.string
};
